var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchLupa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_850_1476)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 8C19.7452 8 9 18.7452 9 32C9 45.2548 19.7452 56 33 56C46.2548 56 57 45.2548 57 32C57 18.7452 46.2548 8 33 8ZM37.4224 35.5948L43.5275 41.6107C43.6317 41.7169 43.7144 41.8433 43.7709 41.9825C43.8273 42.1217 43.8564 42.271 43.8564 42.4219C43.8564 42.5727 43.8273 42.722 43.7709 42.8612C43.7144 43.0005 43.6317 43.1268 43.5275 43.233C43.4241 43.3401 43.3012 43.4251 43.1657 43.4831C43.0302 43.5411 42.8849 43.571 42.7381 43.571C42.5913 43.571 42.446 43.5411 42.3105 43.4831C42.175 43.4251 42.052 43.3401 41.9487 43.233L35.8547 37.2057C34.3008 38.459 32.382 39.139 30.4066 39.1365C28.6473 39.1365 26.9276 38.6005 25.4649 37.5962C24.0021 36.5919 22.862 35.1644 22.1888 33.4943C21.5156 31.8242 21.3394 29.9865 21.6826 28.2135C22.0258 26.4405 22.873 24.812 24.117 23.5337C25.3609 22.2555 26.9458 21.385 28.6713 21.0323C30.3967 20.6796 32.1852 20.8607 33.8105 21.5524C35.4358 22.2442 36.825 23.4157 37.8024 24.9187C38.7797 26.4218 39.3014 28.1889 39.3014 29.9966C39.3039 32.0264 38.6421 33.9981 37.4224 35.5948ZM24.8597 26.1882C24.1267 27.3155 23.7354 28.6408 23.7354 29.9966C23.7354 31.8146 24.4383 33.5582 25.6894 34.8438C26.9404 36.1293 28.6373 36.8515 30.4066 36.8515C31.726 36.8515 33.0158 36.4495 34.1129 35.6963C35.2099 34.943 36.065 33.8724 36.5699 32.6199C37.0748 31.3673 37.2069 29.989 36.9495 28.6593C36.6921 27.3295 36.0567 26.1081 35.1238 25.1494C34.1908 24.1908 33.0021 23.5379 31.708 23.2734C30.414 23.0089 29.0726 23.1446 27.8536 23.6635C26.6346 24.1823 25.5928 25.0609 24.8597 26.1882Z",
    fill: "url(#paint0_linear_850_1476)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_850_1476",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.672092 0 0 0 0 0.759491 0 0 0 0 0.832324 0 0 0 0.599836 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_850_1476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_850_1476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_850_1476",
    x1: 12.5476,
    y1: 32.858,
    x2: 57.8594,
    y2: 34.2962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61008F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9747FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLupa);
export default __webpack_public_path__ + "static/media/SearchLupa.3916bb459d57bcf4a58aadcdf402db6f.svg";
export { ForwardRef as ReactComponent };